import react from 'react';
import { MimaButton, MimaInput, MimaText, Modal } from '../../components';
import { Formik } from 'formik';

const AddNewCategory = ({
    loading,
    validationSchema,
    onSubmit,
    closeModal,
    data,

}) => {
    return (
        <Modal closeModal={closeModal}>
            <Formik
                initialValues={{
                    name: "",
                    description: "",
                }}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    values,
                    errors,
                    touched,
                }) => (
                    <>
                        <MimaText variant="subtitleBold" mb={4}>Add New Category</MimaText>
                        <MimaInput
                            labelTitle="Category Name"
                            name="name"
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.name}
                            touched={touched.name}
                        />
                        <MimaInput
                            labelTitle="Description"
                            name="description"
                            value={values.description}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.description}
                            touched={touched.description}
                        />

                        <MimaButton 
                        title="Add"                        
                        width={38}
                        mt={2}
                        buttonColor="var(--color-dark-4)"
                        onClick={handleSubmit}
                        loading={loading}
                        />
                    </>
                )}

            </Formik>
        </Modal>
    )
}
export default AddNewCategory;